import React from "react";
import PropTypes from 'prop-types';
import { Tooltip } from "@material-ui/core";

export const TooltipTop = (props) => {
    const { disable } = props;
    return <Tooltip
                arrow
                placement="top"
                disableFocusListener={disable}
                disableHoverListener={disable}
                disableTouchListener={disable}
                {...props}
            />;
};

export const TooltipLeft = (props) => {

    return <Tooltip
                arrow
                placement="left"
                {...props}
            />;
};

export const TooltipBottom = (props) => {
    return <Tooltip
                arrow
                placement="bottom"
                {...props}
            />;
};

export const TooltipRight = (props) => {
    const {disable} = props;
    return <Tooltip
                title={props.title}
                arrow
                placement="right"
                disableFocusListener={disable}
                disableHoverListener={disable}
                disableTouchListener={disable}
            >
                {props.children}
            </Tooltip>;
};

TooltipRight.propTypes = {
    disable: PropTypes.bool,
    title: PropTypes.string,
    children: PropTypes.node
};

TooltipTop.propTypes = {
    disable: PropTypes.bool
};